import { api, ERR_OK } from './config';
import axios from '@/common/js/axiox';

export async function getCode(phoneNo) {
  return await axios.get(`${api.getCodeUrl}/${phoneNo}`).then((res) => {
    return res.data;
  });
}

export async function login(phoneNo, token, authCode) {
  const data = {
    phoneNo,
    token,
    authCode
  };
  return await axios.post(api.loginUrl, data).then((res) => {
    return res.data;
  });
}

export async function logout(userId) {
  return await axios.post(`${api.logoutUrl}/${userId}`).then((res) => {
    return res.data;
  });
}

export async function getUserInfo(userId) {
  return await axios.get(`${api.loginUrl}/${userId}`).then((res) => {
    return res.data;
  });
}